/**
 * Announcements catalog for the nav "Announcements" item.
 *
 * HOW TO SHIP A NEW ANNOUNCEMENT:
 * 1. Add a new entry at the TOP of ANNOUNCEMENTS with a UNIQUE id.
 * 2. Pick a DIFFERENT accent than the previous announcement. The badge color
 *    rotation is intentional: it breaks pattern recognition so users don't
 *    subconsciously tune the badge out.
 * 3. The NEW badge reappears automatically for every user who hasn't opened
 *    the panel since this id shipped (seen-state is per-id in localStorage).
 *
 * CHANGELOG GREEN DOT:
 * Bump CHANGELOG_DOT_VERSION whenever a new changelog release ships. The dot
 * shows until the user clicks Changelog once, then hides for that version.
 */

export type AnnouncementAccent =
  | "emerald"
  | "violet"
  | "sky"
  | "amber"
  | "rose";

export interface Announcement {
  /** Unique, stable id. Used as the localStorage seen-key. */
  id: string;
  accent: AnnouncementAccent;
  title: string;
  body: string;
  actionLabel: string;
  actionHref: string;
  thumbnailUrl?: string;
  enabled: boolean;
}

export const ANNOUNCEMENTS: Announcement[] = [
  {
    id: "free-tier-claude-pay-as-you-go-2026-09-20",
    accent: "amber",
    title: "Free plan change: Claude is now pay as you go.",
    body: "The $50 free Claude credit is retired. Gemini stays free at 20 messages a day. Add $10 whenever you want Claude.",
    actionLabel: "Read what changed",
    actionHref: "/updates",
    enabled: true,
  },
  {
    id: "youtube-user-success-333-july-2026",
    accent: "emerald",
    title: "A real trader made $333 using Xynth.",
    body: "See the full journey from signal to research to trade.",
    actionLabel: "Watch the story",
    actionHref: "/library?tab=video",
    thumbnailUrl: "/images/youtube_thumbnail_userstory.png",
    enabled: true,
  },
];

/** Bump this when a new changelog release ships to bring the dot back. */
export const CHANGELOG_DOT_VERSION = "2026-09-20";

export const ANNOUNCEMENT_SEEN_PREFIX = "xynth:announcement:seen:";
export const CHANGELOG_SEEN_PREFIX = "xynth:changelog:seen:";
